import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
    {name:'瑞莱智慧',con:'Tsinghua University',img:'https://img.alicdn.com/imgextra/i4/O1CN01QgVLU31KbrFiJiSX3_!!6000000001183-2-tps-352-86.png'},
    {name:'阿里巴巴集团',con:'Tsinghua University',img:'https://img.alicdn.com/imgextra/i4/O1CN01xU80YI1OKgs4InCbP_!!6000000001687-2-tps-352-86.png'},
]
export default function Sponsors() {
    return <div className="page-sponsors">
            <div className="sponsors-title">Sponsors</div>
            <Row className="list-ul" gutter={[16, 16]}>
                {arrs.map((item, index) => (<Col xl={8} sm={12} span={24} key={index} className="list-li"> 
                    <img src={item.img} alt="" />
                </Col>))}
            </Row>
        </div>
}
